import { pick } from '../../util/lodash';

export const getAdminAccounts = state => state.admin.accounts;
export const getAdminAccountsData = state => getAdminAccounts(state).data;
export const getSelectedAccountId = state => getAdminAccounts(state).selectedAccountId;
export const getSelectedAccount = state => getAdminAccountsData(state)[getSelectedAccountId(state)];
export const getAccountsById = (state, ids) => Object.values(pick(getAdminAccountsData(state), ids));
export const getSelectedAccountDepartments = state => getAdminAccounts(state).selectedAccountDepartments;
export const getIsSubmittingContractDeptChange = state => getAdminAccounts(state).isSubmittingContractDeptChange;
